"use strict";

var DataObject = require('../DataObject');

//Records a click on a link from a song to an external site for purchasing sheet music or a recording
var ExternalLinkClick = DataObject.createDataType({
	init: function(json) {
		this.timeStamp = Date.now();
		
		if (json) {
			if (json.linkType) {
				this._linkType = json.linkType;
				delete json.linkType;
			}
			this.fromJSON(json);
		}
	},
	
	id: null,
	songId: null,
	_linkType: null,	//score or recording?
	siteId: null,	//string ID of the external site (same as used in the externalLinks array for songs)
	userId: null,  //ID of the user who clicked the link
	subscriptionId: null,  //subscription ID (if any) of the user who clicked the link
	
	get linkType() {return this._linkType},
	set linkType(linkType) {
		if (linkType !== 'score' && linkType !== 'recording') {
			throw Error('Invalid link type: "' + linkType + '"');
		}
	}
});

module.exports = ExternalLinkClick;